import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

import { checkIsRouteAuthorized } from "@/security/authorization";
import { usePreferencesStore } from "@/stores/preferences";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavbarMenuOntologyTab',
  setup(__props) {

const preferencesStore = usePreferencesStore();

const frequentOntologies = computed(() => {
  const frequentOntologiesArray = Object.entries(
    preferencesStore.frequentOntologies
  ).map(([ontologyId, ontology]) => ({
    id: ontologyId,
    ...ontology,
  }));
  frequentOntologiesArray.sort((a, b) =>
    a.count < b.count ? 1 : a.count > b.count ? -1 : 0
  );
  return frequentOntologiesArray.slice(0, 5);
});

return { __sfc: true,preferencesStore, frequentOntologies, checkIsRouteAuthorized }
}

})